import React from 'react'

export default function ImgDiv(props) {
  return (
    <div className="col-12 col-md-9 img-holder">
            <img
              src={props.img}
              alt="img"
              className="img-fluid img-details w-100"
            />
            <div>
              <h1 className="main-photo-text">{props.title}</h1>
            </div>
          </div>
  )
}
